import React, { useState, useEffect, useReducer, useRef } from 'react';
import ConversationIndex from './conversation_index';
import ChildWindows from './child_windows';
import PropTypes from 'prop-types';
import { api } from '../../shared/utils/api';
import { useInterval } from '../../shared/hooks/use_interval';
import BeatLoader from 'react-spinners/BeatLoader';
import {
  conversationListReducer,
  convoWindowReducer,
  defaultConvoWindowState,
  FETCH_CONVERSATION_LIST,
  UPDATE_CONVERSATION_LIST_ASYNC,
  OPEN_NEW_CONVERSATION_WINDOW,
  OPEN_RUNNING_CONVERSATION_WINDOW,
  CLOSE_CONVERSATION_WINDOW,
  UPDATE_RUNNING_CONVERSATION_WINDOWS
} from '../reducers/messenger_reducers';

const MessengerWindow = ({ creator }) => {
  const [convoWindowState, dispatchConvoWindowAction] = useReducer(
    convoWindowReducer,
    defaultConvoWindowState
  );
  const [conversationListState, dispatchConversationListAction] = useReducer(
    conversationListReducer,
    []
  );

  const [showSelf, setShowSelf] = useState(false);
  const [searchInput, setSearchInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [totalUnreadCount, setTotalUnreadCount] = useState(0);
  const inputRef = useRef(null);

  useEffect(() => {
    setIsLoading(true);
    api.get('/messenger').then((res) => {
      dispatchConversationListAction({
        type: FETCH_CONVERSATION_LIST,
        conversations: res.data.conversations
      });
      setIsLoading(false);
    });
  }, []);

  useEffect(() => {
    const intercom = document.getElementsByClassName(
      'intercom-lightweight-app'
    )[0];

    if (!showSelf && intercom) {
      setTimeout(() => {
        intercom.classList.remove('hidden');
      }, 500);
    } else if (intercom) {
      intercom.classList.add('hidden');
    }
  }, [showSelf]);

  useEffect(() => {
    if (isLoading && conversationListState.length > 0) {
      setIsLoading(false);
      setTotalUnreadCount(
        conversationListState.reduce(
          (acc, val) => acc + val.unreadMessageCount,
          0
        )
      );
    }

    if (convoWindowState.windows.length > 0) {
      dispatchConvoWindowAction({
        type: UPDATE_RUNNING_CONVERSATION_WINDOWS,
        conversations: conversationListState
      });
    }
  }, [conversationListState]);

  useInterval(() => {
    handleReload();
  }, 10000); //pole every 10seconds

  useEffect(() => {
    if (!isLoading && inputRef.current) {
      inputRef.current.focus();
    }
  }, [convoWindowState]);

  const openMessageCreatorWindow = (e) => {
    if (e) e.stopPropagation();
    dispatchConvoWindowAction({ type: OPEN_NEW_CONVERSATION_WINDOW });
  };

  const openRunningConversationWindow = (convo) => {
    dispatchConvoWindowAction({
      type: OPEN_RUNNING_CONVERSATION_WINDOW,
      convo
    });
  };

  const handleClose = (e, id) => {
    e.stopPropagation();
    dispatchConvoWindowAction({ type: CLOSE_CONVERSATION_WINDOW, id });
  };

  const handleSearch = (e) => setSearchInput(e.target.value);

  const handleReload = () => {
    const listIds = conversationListState.map((convo) => convo.id);
    const listTimes = conversationListState.map((convo) => convo.day);
    api
      .post(
        '/messenger/pole_new_messages',
        { list_ids: listIds, list_times: listTimes },
        { baseURL: '/' }
      )
      .then((res) => {
        const { new_messages, new_conversations } = res.data;

        if (
          new_conversations.length > 0 ||
          Object.entries(new_messages).length
        ) {
          dispatchConversationListAction({
            type: UPDATE_CONVERSATION_LIST_ASYNC,
            latestMessages: new_messages,
            newConversations: new_conversations,
            setTotalUnreadCount,
          });
        }
      });
  };

  return (
    <div>
      <div
        className={`module messenger-window wrapper ${
          !showSelf ? 'shrink' : ''
        }`}
      >
        <div
          className="module-header display-flex justify-between mb-15 pointer"
          onClick={() => setShowSelf(!showSelf)}
        >
          <div>
            <p className="h5 w3">INBOX</p>
            {totalUnreadCount >= 1 && (
              <div className="badge-avatar inbox">
                <span>{totalUnreadCount}</span>
              </div>
            )}
          </div>
          <i
            className="fa fa-pen pointer icon"
            onClick={openMessageCreatorWindow}
          />
        </div>
        <div>
          <input
            placeholder="Search"
            type="text"
            className="form-control search"
            onChange={handleSearch}
            value={searchInput}
          />
        </div>

        <div className="index-container">
          {isLoading ? (
            <BeatLoader
              color="#3d898b"
              speedMultiplier={0.5}
              className="mt-50 text-center"
            />
          ) : (
            <ConversationIndex
              indexList={conversationListState}
              searchInput={searchInput}
              handleNewConversationWindow={openRunningConversationWindow}
              handleTotalUnreadCount={setTotalUnreadCount}
              handleConversationList={dispatchConversationListAction}
            />
          )}
        </div>
      </div>
      {!isLoading && (
        <ChildWindows
          conversationWindows={convoWindowState.windows}
          handleNewConversationWindow={openRunningConversationWindow}
          handleClose={handleClose}
          dispatchConversationListAction={dispatchConversationListAction}
          convoList={conversationListState}
          creator={creator}
          handleTotalUnreadCount={setTotalUnreadCount}
          inputRef={inputRef}
        />
      )}
    </div>
  );
};

MessengerWindow.propTypes = {
  creator: PropTypes.object.isRequired
};

export default MessengerWindow;
